import { FC } from "react";
import { Input } from "shared/components";

type Props = {
  title: string;
  value: string;
  editMode: boolean;
  password?: boolean;
  onChange?: (value: string) => void;
};

export const SettingsItem: FC<Props> = ({
  title,
  value,
  editMode,
  password,
  onChange
}) => {
  return (
    <>
      <h3 className="mb-2 text-sm font-medium text-content-300">{title}</h3>
      {editMode ? (
        <Input
          id="accessKey"
          value={value}
          className="w-full"
          onChange={(e) => onChange?.(e.target.value)}
        />
      ) : (
        <p className="text-sm font-medium text-content-1000 truncate">
          {value ? (password ? value.replace(/./g, "*") : value) : ""}
        </p>
      )}
    </>
  );
};
